module.exports = __webpack_public_path__ + "static/MetroInc_pin_hover-896d0b4e6a19a693c166c610d8466a08.png";